import React, { useState, useEffect } from 'react';
import { createModel } from 'hox';
import useGlobalModel from '@/model/globalModel';
import { applyListService } from '../../applyListService';
import { useLockFn } from 'ahooks';
import {
	ISCMApplyListFormFields,
	ISCMApplyListInsert,
	ISCMApplyListUpdate,
	ISCMSDcGoodsDetail,
	ISCMSDcGoodsOne,
} from '../../applyListTypes';
import { globalPrompt } from '@/components/message';
import { CLIENT_APP_CODE } from '@/utils/constants';
import { formatNum, momentFormat } from '@/utils/utils';
import useNavModel from '@/model/navModel';
import { useDictModel } from '@/views/base/dict/dictModel';
import { useApplyListModel } from '../../applyListModel'
import { message } from 'antd';
import { convertRes2Blob } from '@/utils/exportFile';


export const useApplyListDetailsModel = createModel(function () {
	const { selectedRowKeys } = useApplyListModel()
	const { user: { userName }, fetchUserList, userData } = useGlobalModel();
	const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
	const initFormVal = {
		// createUser: userName,
		applier: userName,
		branchOut: CLIENT_APP_CODE,
		discountTotalAmount: '0.00', //优惠总额
		favorableAmount: '0', //整单优惠
		aggregateAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
	} as ISCMApplyListFormFields;
	const { selectedNavId, replaceNav, findNav } = useNavModel()
	//编辑缓存
	const [editFormVal, setEditFormVal] = useState<ISCMApplyListFormFields>(initFormVal);

	//新增缓存
	const [addFormVal, setAddFormVal] = useState<ISCMApplyListFormFields>(initFormVal);

	// 控制先保存
	const [saveBtn, setSaveBtn] = useState<boolean>(false);
	// 保存按钮的loading效果
	const [saveBtnLoading, setSaveBtnLoading] = useState<boolean>(false);
	const [departmentOutValue, setDepartmentOutValue] = useState<string>('');   //用于搜索展示的数据
	//导入点击
	const [changeImport, setChangeImport] = useState<boolean>(true)
	const [getOneData, setGetOneData] = useState<any>({});
	const [getOneNameList, setGetOneNameList] = useState<any>([]);
	const [detialSelect, setDetialSelect] = useState<any>([]);  //选择默认值
	const [nextApplyUser, setNextApplyUser] = useState<string>('');  //下一级审批人
	const [applyVisible, setApplyVisible] = useState<boolean>(false);  //下一级审批人
	const [applyHistoryList, setApplyHistoryList] = useState<any>([]);  //审批记录
	const [upFileList, setUpFileList] = useState<any>([])//已上传成功的图片
	const [addGoodsList, setAddGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [editGoodsList, setEditGoodsList] = useState<ISCMSDcGoodsDetail[]>([]);
	const [applyDetailList, setApplyDetailList] = useState<any>([]);  //审批记录
	const [selectedKeys, setSelectedKeys] = useState<string[]>([])
	const [selectedRowRows, setSelectedRowRows] = useState<any>([])
	const [allNameList, setAllNameList] = useState<any>([]);  //选择默认值
	const [addUserVisible, setAddUserVisible] = useState<boolean>(false);
	const [addListVisible, setAddListVisible] = useState<boolean>(false);
	const [addUserData, setAddUserData] = useState<any>({});
	const [editUserData, setEditUserData] = useState<any>({});
	const [formVal, setFormVal] = useState<any>({});
	useEffect(() => {
		resetAddCatch();
		setAddFormVal({ ...initFormVal });
	}, []);

	//表单新增修改
	const updateAddFormVal = (val: object | null) => {
		val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initFormVal);
	};
	//表单编辑修改
	const updateEditFormVal = (val: object | null) => {
		val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal(initFormVal);
	};

	//重置缓存
	const resetEditCatch = () => {
		updateEditFormVal(null); //表单
		setGetOneData([])
		setDetialSelect([])
		setUpFileList([])
		setEditGoodsList([]); //详情商品列表
		setEditSelectGoods([]); //弹框已选商品

	};
	const resetAddCatch = () => {
		updateAddFormVal(null);
		setUpFileList([])
		setAddGoodsList([]);
		setAddSelectGoods([]);
	};
	//表单物资校验 (开单数量不能为0)
	const verifyGoods = async (mode: string): Promise<boolean> => {
		let goods = mode === 'edit' ? editGoodsList : addGoodsList;
		let formVal = mode === 'edit' ? editFormVal : addFormVal;

		if (!goods.length && formVal.typeCode !== 'assets-apply-type.purchase') {
			message.warning('请添加物品明细');
			return false;
		}
		if (formVal.typeCode == 'assets-apply-type.transfer' && goods.find((item) => item.user && item.user == item.beforeUser)) {
			const answer = await new Promise<boolean>((resolve) => {
				globalPrompt('modal', {
					title: '转移申请保存提醒',
					type: 'warning',
					text: `是否需要更新现使用人`,
					okText: '确认',
					onOk: () => {
						resolve(false); // 确认返回 false
					},
					cancelText: '取消',
					onCancel: () => {
						resolve(true); // 取消返回 true
					},
				});
			});
			return answer;
		}
		let warehouseNum = goods.filter((item) => !item.warehouseCode || !item.shelfCode);
		let user = goods.filter((item) => !item.userCode);

		if (warehouseNum.length) {
			message.warning(
				`【${warehouseNum.map((item) => item.materialName).join()}】物资的仓库及货位不能为空`
			);
			return false;
		}
		return true;
	};

	//获取一条数据
	const getSDcDetailOne = async (id: string) => {
		let { retData } = await applyListService.one(id);
		let { processDetails, details, ...formVal } = retData;
		setEditGoodsList(() => details.map((item) => ({ ...item, key: item.id, temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000), })));
		if (retData) {
			// let fileList: any = []
			// const { md5, fileName } = formVal
			// if (md5) {
			//     fileList = [
			//         {
			//             uid: md5,
			//             status: 'done',
			//             name: fileName,
			//             response: {
			//                 retData: md5,
			//             },
			//         },
			//     ]
			// }
			// formVal.fileList = fileList
			const { fileList } = formVal
			if (fileList.length > 0) {
				formVal.fileList = fileList.map((list) => {
					return {
						uid: list.md5,
						status: 'done',
						name: list.fileName,
						response: { retData: list.md5, }
					}
				})
			}
			const hasIdFive = Object.values(processDetails).some((arr: any) =>
				arr.some(item => item.isApprove === 1)
			);
			setEditFormVal({ ...formVal, hasIdFive, createTime: momentFormat(formVal.createTime) ?? '' });
			fetchUserList(formVal.department)
			setGetOneData(retData.processDetails)
			setGetOneNameList(Object.keys(retData.processDetails))
			let newList: any = []
			let nameList: any = []
			Object.keys(retData.processDetails).map((item) => {
				if (retData.processDetails[item][0].status) {
					newList.push(item)
				}
				retData.processDetails[item].map((list) => {
					nameList.push(list.userCode)
				})
			})
			setAllNameList(nameList)
			setDetialSelect(newList)
			let logList: any = []
			Object.keys(retData.processDetails).map((item) => {
				retData.processDetails[item].map((list) => {
					if (list.isReviewer && list.isApprove) {
						logList.push(list)
					}
				})
			})
			setApplyHistoryList(logList)
		}
		return retData;
	};



	//新增 Api
	const insertSDc = useLockFn(async (val: ISCMApplyListFormFields) => {
		setSaveBtnLoading(true);
		try {
			let data: ISCMApplyListInsert = {
				...val,
				details: addGoodsList,
			};
			let { retData } = await applyListService.insert(data);
			globalPrompt("message", { text: "申请列表新增成功", type: "success" })
			setSaveBtnLoading(false);
			replaceNav(selectedNavId, '5-1')
			resetAddCatch();
			return retData;
		} catch (error) {
			setSaveBtnLoading(false);
		}
	});

	//编辑 Api
	const updateSDc = useLockFn(async (val: ISCMApplyListFormFields & { id: string }) => {
		setSaveBtnLoading(true);
		try {
			let data: ISCMApplyListUpdate = {
				...val,
				id: editFormVal.id,
				details: editGoodsList,
			};
			let { retData } = await applyListService.update(data);
			globalPrompt("message", { text: "申请列表编辑成功", type: "success" })
			setSaveBtnLoading(false);
			replaceNav(selectedNavId, '5-1')
			resetEditCatch()
			return retData;
		} catch (error) {
			setSaveBtnLoading(false);
		}
	});
	//审批操作
	const onApply = () => {
		if (selectedRowKeys.length !== 1) {
			globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
			return
		}
		getSDcDetailOne(selectedRowKeys[0]).then((retData) => {
			setApplyDetailList(retData.details)
			let newName: string = ''
			Object.keys(retData.processDetails).map((item) => {
				if (newName) {
					return
				}
				else if (retData.processDetails[item].find((list) => !list.isApprove && list.status)) {
					newName = item
					return
				}

			})
			setNextApplyUser(newName)
			if (retData.processDetails[newName] && retData.processDetails[newName].find((list) => list.user == userName)) {
				setApplyVisible(true)
			}
			else {
				message.warning('您无此条单据的审批权限')
			}
			let newList: any = []
			Object.keys(retData.processDetails).map((item) => {
				retData.processDetails[item].map((list) => {
					if (list.isReviewer && list.isApprove) {
						newList.push(list)
					}
				})
			})
			setApplyHistoryList(newList)
		})
	};
	/**
	 * 商品新增
	 */
	const [addGoodsModal, setAddGoodsModal] = useState<boolean>(false); //商品弹框
	const [editSelectGoods, setEditSelectGoods] = useState<any[]>([]); //已选的商品
	const [addSelectGoods, setAddSelectGoods] = useState<any[]>([]); //已选的商品
	// 操作数据先保存
	const [buttonControl, setButtonControl] = useState<boolean>(false);

	//添加商品  默认数量字段为1
	const add = async (record: any, mode: string) => {
		const isEdit: boolean = mode === 'edit';
		isEdit
			? setEditSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }])
			: setAddSelectGoods((origin) => [...origin, { ...record, sDcNum: 1 }]);
	};

	//删除商品 选中的
	const remove = (record: any, mode: string) => {
		mode === 'edit'
			? setEditSelectGoods((origin) => origin.filter((item) => item.id !== record.id))
			: setAddSelectGoods((origin) => origin.filter((item) => item.id !== record.id));
	};

	//选中的物资转商品
	const transformsToSDcGoods = useLockFn(async (selectList: any[], mode: string) => {
		if (mode === 'edit') {
			setButtonControl(true);
			setSaveBtn(true);
		}
		const isEdit: boolean = mode === 'edit';
		let codeList: string[] = [];
		let goodsList = mode === 'add' ? addSelectGoods : editSelectGoods;
		const dataSourse = mode === 'add' ? addFormVal : editFormVal
		goodsList.forEach((item) => {
			codeList.push(item.materialCode);
		});
		if (codeList.length === 0 && selectList.length === 0) {
			setAddGoodsModal(false)
			return
		}
		const newDetailData: any = [];
		selectList.forEach((item) => {
			newDetailData.push({
				materialCode: item.materialCode,
				barCode: item.barCode,
				materialName: item.materialName,
				model: item.model,
				typeCode: item.typeCode,
				code: item.code,
				price: item.price,
				unitCode: item.unitCode,
				detailsId: item.id,
				id: '',
				num: item.num,
				warehouseName: dataSourse.typeCode == 'assets-apply-type.transfer' ? item.warehouseName : '报废库',
				amount: item.amount ?? item.price,
				warehouseCode: dataSourse.typeCode == 'assets-apply-type.transfer' ? item.warehouseCode : 'WH-M-00000701',
				shelfCode: dataSourse.typeCode == 'assets-apply-type.transfer' ? item.shelfCode : '',
				note: "",
				temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
				beforeDeposit: item.deposit,
				beforeUser: item.user,
				beforeUserCode: item.userCode,
				user: item.user,
				userCode: item.userCode,
				typeName: item.typeName,
				unitName: getTreeNodeName(item.unitCode) ?? '',
				brandName: item.brandName,
				md5: item.md5,
				fileName: item.fileName,
				// warehouseCode:null,
				// warehouseName:null,
				// shelfCode:null,
			});
		});

		isEdit
			? setEditGoodsList((origin) => [...origin, ...newDetailData])
			: setAddGoodsList((origin) => [...origin, ...newDetailData]);
		isEdit ? setEditSelectGoods([]) : setAddSelectGoods([]);
		setAddGoodsModal(false);
	});
	//下载模板
	const downloadTpl = async () => {
		let result = await applyListService.downloadTpl();
		convertRes2Blob(result)
	}

	return {
		editFormVal,
		addFormVal,
		updateAddFormVal,
		updateEditFormVal,
		resetEditCatch,
		resetAddCatch,
		/**api */
		insertSDc,
		updateSDc,
		downloadTpl,
		getSDcDetailOne,
		onApply,
		/**商品详情 */
		saveBtn,
		setSaveBtn,
		saveBtnLoading,
		setSaveBtnLoading,
		changeImport,
		setChangeImport,
		getOneData,
		setGetOneData,
		detialSelect,
		setDetialSelect,
		nextApplyUser,
		setNextApplyUser,
		applyVisible,
		setApplyVisible,
		applyHistoryList,
		setApplyHistoryList,
		upFileList,
		setUpFileList,
		departmentOutValue,
		setDepartmentOutValue,
		addGoodsList,
		setAddGoodsList,
		editGoodsList,
		setEditGoodsList,
		addGoodsModal,
		setAddGoodsModal,
		editSelectGoods,
		setEditSelectGoods,
		addSelectGoods,
		setAddSelectGoods,
		buttonControl,
		setButtonControl,
		add,
		remove,
		transformsToSDcGoods,
		verifyGoods,
		applyDetailList,
		setApplyDetailList,
		selectedRowRows,
		setSelectedRowRows,
		selectedKeys,
		setSelectedKeys,
		allNameList, setAllNameList,
		getOneNameList, setGetOneNameList,
		addUserVisible, setAddUserVisible,
		addUserData, setAddUserData,
		editUserData, setEditUserData,
		formVal, setFormVal,
		addListVisible, setAddListVisible
	};
});
